import React from 'react';

import CliveChatMessage from '../Chat/CliveChatMessage';

import Button from '~/core/atoms/Buttons/Button';
import { Spinner } from '~/core/atoms/Spinner';
import cn from '~/utils/cn';

interface CliveCreateClaimMessageProps {
  onCreateClaim?: () => void;
  disabled?: boolean;
  isLoading?: boolean;
  isClaimCreated?: boolean;
  showRetry?: boolean;
}

const CliveCreateClaimMessage: React.FC<CliveCreateClaimMessageProps> = ({
  onCreateClaim,
  disabled = false,
  isLoading = false,
  isClaimCreated = false,
  showRetry = false,
}) => {
  const message = (
    <span className="flex flex-col items-start gap-20">
      <span>
        Here is a draft FNOL. Would you like me to add any additional details? Otherwise, you can submit the FNOL by
        clicking the "Create Claim" button below.
      </span>
      <div className="flex items-center gap-12">
        <Button
          className={cn({
            'bg-yellow-700': showRetry,
          })}
          variant="primary"
          size="xs"
          outline
          onClick={onCreateClaim}
          disabled={disabled || isLoading || isClaimCreated}
        >
          {isLoading ? (
            <span className="flex items-center gap-8">
              <Spinner size="sm" />
              CREATING CLAIM...
            </span>
          ) : showRetry ? (
            'Something went wrong. Retry?'
          ) : isClaimCreated ? (
            'CLAIM CREATED!'
          ) : (
            'CREATE CLAIM'
          )}
        </Button>
      </div>
    </span>
  );

  return <CliveChatMessage message={message} isLoading={isLoading} />;
};

export default CliveCreateClaimMessage;
